import WidgetCard from './widgetCard.vue';
export default {
  name: 'Widget',
  components: {
    WidgetCard
  },
  props: {
    widget: {
      type: Object,
      required: true
    },
    dataSet: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showInFullScreen: false
    };
  }
};